import { render, staticRenderFns } from "./addressEdit.vue?vue&type=template&id=4c305a9a&scoped=true"
import script from "./addressEdit.vue?vue&type=script&lang=js"
export * from "./addressEdit.vue?vue&type=script&lang=js"
import style0 from "./addressEdit.vue?vue&type=style&index=0&id=4c305a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c305a9a",
  null
  
)

export default component.exports